import { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Modal,
  Typography,
  Box,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Bar } from "react-chartjs-2";
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Label } from "@mui/icons-material";
import "./AnalyticsPage.css";
import {
  NavLink
} from "react-router-dom";
import { BASE_API_URL } from "../utils/constants";
const AnalyticsPage = () => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [monthView, setMonthView] = useState([]);
  const [open, setOpen] = useState(null);
  const [selectedBarData, setSelectedBarData] = useState(null);

  useEffect(() => {
    getAnalytics();
  }, [selectedYear]);
  console.log("data", monthView);

  const getAnalytics = async () => {
    try {
      const response = await axios.post(`${BASE_API_URL}/yearanalytics`, {
        year: selectedYear,
      },
    {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        });
      setMonthView(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const downloadFile = async () => {
    try {
      const response = await axios.get(`${BASE_API_URL}/downloadAnalytics`, {
        responseType: "blob",
        headers: {
          Authorization: localStorage.getItem("token"),
          //"Content-Type": "application/json",
        }
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");

      if (!link) {
        console.error("Error creating link element");
        return;
      }

      link.href = url;
      link.setAttribute("download", "data.xlsx");
      document.body.appendChild(link);

      if (typeof link.click !== "function") {
        console.error("Error: click() method not available");
        return;
      }

      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const fillMissingMonths = () => {
    const filledMonthView = [];
    for (let i = 1; i <= 12; i++) {
      const monthData = monthView
        .map((innerArray) => innerArray.Data.filter((item) => item.month === i))
        .flat(); // Flatten the array of arrays
      const totalViews = monthData.reduce(
        (acc, cur) => acc + cur.total_views,
        0
      );
      const totalViewsByEnterprise = monthData.map((userView) => {
        return {
          enterprise_id: userView.enterprise_id,
          total_views: userView.total_views,
        };
      });
      const enterprise_id = monthData.map((item) => item.enterprise_id);
      console.log("month", monthData);
      if (monthData.length > 0) {
        filledMonthView.push({
          year: selectedYear,
          month: i,
          totalUniqueUsers: monthData.length,
          total_views: totalViews,
          total_views_by_enterprise: totalViewsByEnterprise,
        });
      } else {
        filledMonthView.push({
          year: selectedYear,
          month: i,
          totalUniqueUsers: 0,
          total_views: 0,
          total_views_by_enterprise: [],
        });
      }
    }
    return filledMonthView;
  };
  const handleBarClick = (event) => {
    const activeElement = event.chart.getElementsAtEventForMode(
      event,
      "nearest",
      { intersect: true },
      true
    )[0];
    if (activeElement) {
      const { index } = activeElement;
      console.log("fill", fillMissingMonths()[index]);
      setSelectedBarData(fillMissingMonths()[index]);
      setOpen(index);
    }
  };
  const options = {
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Views",
          color: "grey",
          font: {
            weight: "bold",
          },
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Unique and Total Views Bar Chart",
        padding: 20,
        color: "#6e0089a6",
        font: {
          size: 20,
        },
      },
      datalabels: {
        color: "#6e0089",
        anchor: "end",
        align: "top",
        offset: 0,
        font: {
          weight: "bolder",
        },
      },
    },
    responsive: true,
    onClick: handleBarClick,
  };
  // Prepare data for chart
  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  console.log(
    "check",
    fillMissingMonths().map((item) => item.total_views_by_enterprise)
  );
  const chartData = {
    labels,
    datasets: [
      {
        label: "Unique Views",
        data: fillMissingMonths().map((item) => item.totalUniqueUsers),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Total Views",
        data: fillMissingMonths().map((item) => item.total_views),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };
  const handleCloseModal = () => {
    setOpen(null);
  };
  console.log(
    "modal",
    selectedBarData !== null &&
      selectedBarData.total_views_by_enterprise.map(
        (item) => item.enterprise_id
      )
  );
  return (
    <>
      <div>
        <div>
          <Modal
            open={open !== null}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="custom-modal"
          >
            <Box className="tableWrapper">
              <TableContainer component={Paper} className="tableContainer">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="tableHeaderCell">
                        Enterprise ID
                      </TableCell>
                      <TableCell className="tableHeaderCell">
                        Total Views
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedBarData &&
                      selectedBarData.total_views_by_enterprise.map(
                        (item, index) => (
                          <TableRow
                            className="tableRow"
                            key={index}
                            sx={{
                              backgroundColor:
                                index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                            }}
                          >
                            <TableCell className="tableCell">
                              {item.enterprise_id}
                            </TableCell>
                            <TableCell className="tableCell">
                              {item.total_views}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Modal>
        </div>
      </div>
      <div id="date-picker-container">
        <Button
          onClick={downloadFile}
          style={{ height: "30px" }}
          size="small"
          variant="outlined"
        >
          Download
        </Button>
        <DatePicker
          selected={new Date(selectedYear, 0, 1)}
          onChange={(date) => setSelectedYear(date.getFullYear())}
          dateFormat="yyyy"
          showYearPicker
          className="yearPicker"
        />
        <div className="home_section_analytics">
          <NavLink to="/">
          <img src={process.env.PUBLIC_URL +"/images/Home/home-icon.svg"} alt="home_icon" className="Home_img"/>
          </NavLink>
        </div>
      </div>
      <div className="bar-container">
        <Bar plugins={[ChartDataLabels]} data={chartData} options={options} />
      </div>
    </>
  );
};

export default AnalyticsPage;
